import React, { useState, useEffect } from 'react';
import { Button, Modal, Upload, message, Input, } from 'antd';
import { CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import './attachDocumentModal.css'
import stdApplyJobModalStroke from '../../public/img/std/stdApplyJobModalStroke.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import tag1 from '../../public/img/tag/tag1.png';

const AttachDocumentModal = (props) => {

    const [documentFileList, setDocumentFileList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [description, setDescription] = useState('');
    const [fileSize, setFileSize] = useState('');

    useEffect(() => {
        searchFileSize()
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const handleTextAreaChange = (event) => {
        setDescription(event.target.value);
    };

    const onCancel = (flag) => {
        if (flag) {
            if (Base.isEmpty(documentFileList) && description === '') {
                message.error('Please input Attachment or Additional Information')
                return
            }
            props.onClose(flag, documentFileList, description);
        } else {
            props.onClose(flag);
        }
    };

    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    const downloadFile = (item) => {
        if (item.lastModified) {
            return;
        }
        item.code = "PROPERTY_PATH";
        fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
            method: 'POST',
            body: JSON.stringify(item),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, item.name);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = item.name;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        })
    }

    const beforeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 3) {
            message.error('Maximum uploads 3 files.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='805px'//弹框宽度
            footer={false}
            className='attachDocumentModal'
        >
            <div className='box'>
                <div className='title'>Provide More Info</div>
                <div className='row'>
                    <div className='label'>Additional Information</div>
                    <Input.TextArea rows={3} maxLength={500}
                        value={description}
                        onChange={handleTextAreaChange}
                    />
                </div>
                <div className='row attachment'>
                    <div className='label'>Attachment</div>
                    <Upload
                        maxCount={3}
                        beforeUpload={beforeUpload}
                        action={Config.uploadTestServer}
                        key={"1"}
                        accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                        fileList={documentFileList}
                        onChange={(file) => handleDocumentChange(file)}
                        showUploadList={false}>
                        <Button icon={<UploadOutlined />}>Select Document</Button>
                    </Upload>
                </div>
                <div className='row attachment'>
                    <div className='label'></div>
                    <div className='allFileBox'>
                        {documentFileList.map((item, index) =>
                            <div className="uploadFileRow " key={index} title={item.name}>
                                <img src={tag1} className="tagImg"></img>
                                <div className='fileBox'>{item.name}</div>
                                <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFile(index)} />
                            </div>
                        )}
                    </div>
                </div>
                <div className='row'>
                    Maximum upload 3 files and each file could not exceed 10MB limit.<br/>
                    File type: .pdf, .ptt, .pptx, .doc, .docx, .xls, .xlsx, .jpeg, .jpg, .png, .bmp, .tiff, .mp3, .wav, .txt only.<br/>
                    The additional information/files will be sent to the industry partner and visible to the module convenor.
                </div>
                <div className="buttonBox">
                    <div className='saveButton' onClick={() => onCancel(true)}><img src={stdApplyJobAdd} />Save</div>
                    <div className='cancelButton' onClick={() => onCancel(false)}><img src={stdApplyJobModalStroke} />Cancel</div>
                </div>
            </div>
        </Modal>
    )
}

AttachDocumentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    jobApplModel: PropTypes.object.isRequired,
}
export default AttachDocumentModal;